import { useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const SIZE_CLASS = {
  sm: "h-8 w-8 text-xs",
  md: "h-12 w-12 text-sm",
  lg: "h-20 w-20 text-2xl",
  xl: "h-24 w-24 text-3xl",
};

function initials(name = "") {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "?";
}

/**
 * Round avatar that tries the worker's approved ID photo first and falls back
 * to initials + brand color if the endpoint 404s (no photo yet).
 *
 * `workerId`   – required. `bust` – any string that changes to force refresh.
 * `size`       – "sm" | "md" | "lg" | "xl"
 */
export default function WorkerAvatar({ workerId, name, size = "md", bust, className = "" }) {
  const [failed, setFailed] = useState(false);
  const src = workerId && !failed
    ? `${BACKEND}/api/workers/${workerId}/avatar${bust ? `?v=${bust}` : ""}`
    : null;

  return (
    <div
      className={`rounded-full flex items-center justify-center overflow-hidden shrink-0 font-semibold ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
      style={{
        backgroundColor: "var(--brand-primary-tint, #dbeafe)",
        color: "var(--brand-primary, #012E88)",
      }}
      data-testid={`worker-avatar-${workerId || "none"}`}
    >
      {src ? (
        <img
          src={src}
          alt={name || "Worker"}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span aria-hidden>{initials(name)}</span>
      )}
    </div>
  );
}
